export const operationsManager = {
  id: 'operations-manager',
  version: 2,
  renderer: 'enterprise',
  name: 'Operations Manager Pro',
  layout: 'single-column',
  theme: 'classic-navy',
  density: 'compact',
  persona: ['consulting'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 45,
    visual: 20,
    executive: 25,
    student: 10
  },
  metadata: {
    industry: ['Supply Chain', 'Logistics', 'Corporate Operations'],
    companies: ['FedEx', 'Amazon Ops', 'DHL', 'UPS', 'Maersk', 'Walmart Ops'],
    ats: ['Workday', 'Taleo', 'SuccessFactors'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    columns: 1,
    experienceLevel: ['Mid-level', 'Senior', 'Executive'],
    careerStage: 'Professional',
    recommendedFor: ['Operations Managers', 'Logistics Directors', 'Supply Chain Analysts', 'Project Managers'],
    avoidFor: ['Creative Directors', 'Software Engineers', 'Academic Researchers'],
    dna: ['Ops-Traditional', 'ATS-Scannable', 'Efficiency-Driven', 'Inter-Sans', 'Navy-Professional'],
    metrics: {
      readingDifficulty: 96,
      scanningSpeed: 96,
      visualAppeal: 84
    },
    hiringManager: {
      firstImpression: "Highly efficient, structured operations partner with deep process capabilities",
      scanningStyle: "Linear scanning focusing on cost reduction, efficiency metrics, team management, and logistics tools",
      preferredStructure: "Summary, experience, education, skills",
      dislikes: ["Objective statements", "Creative layouts", "Spelling errors or inconsistent margins"]
    },
    strategy: {
      goal: "Pass standard logistics/operations ATS checks and project structured efficiency metrics",
      focus: "Cost savings, delivery performance, supply chain scaling, process optimization",
      avoid: ["Gimmicky design tokens", "Secondary columns"]
    },
    psychology: {
      coreTraits: ["Efficiency", "Compliance", "Structure", "Execution"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Start bullet points with strong operational action verbs (e.g. 'optimized', 'reduced', 'scaled'). Highlight exact cost and efficiency metrics (e.g. 'reduced shipping costs by 12%', 'managed team of 25+ logistics reps').",
      rewriteStyle: "Formal, operational, metric-driven"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'education', 'skills']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '24px'
      }
    }
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'education', 'skills'],
  components: {
    header: 'personal-info',
    main: ['summary', 'experience', 'education', 'skills'],
  },
  capabilities: {
    photo: false,
    icons: false,
    multiColumn: false,
    colorAccent: false,
    atsOptimized: true,
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.06em',
    '--heading-weight': '700',
    '--border-thickness-heading': '2px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '22px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px'
  }
};
export default operationsManager;
